var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"scroll",attrs:{"flat":""}},[_c('q-card-section',{staticClass:"q-py-none"},[_c('AdvertiserListConversionReports')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }